import { SkeletonProps } from './props.js'

export function Skeleton({ className = '', lines = 1 }: SkeletonProps) {
  return (
    <div className={className}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="h-4 bg-surface-high rounded-md animate-shimmer mb-2"
        />
      ))}
    </div>
  )
}
